define('shared/util/validate/validators/function',['shared/lib/validate'], function  ( validate ) {
    var KEY = 'function';

    function validator(value, options, key, attributes){
        if (typeof options.func === KEY) {
            return options.func(value, options, key, attributes);
        }
        else {
            throw new Error('function validator option must be a function');
        }
    };

    // register to validate js
    validate.validators[KEY] = validator;
    validator.KEY = KEY;

    return validator;
});
